import { Dropdown, Switch } from 'antd';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { DeleteIcon } from '../../../../assets/icons/common/common-icons';
import { ModifiedTooltip } from '../../../../common/components/ModifiedTooltip/ModifiedTooltip';
import { CommonActionMenuItem, DeleteIconContainer } from '../../../../common/styles/menus.styles';
import { useStore } from '../../../app/data/root.store';
import { holdingEntityBackgroundColors } from './background-colors/holding-entity-background-colors';
import { DeleteHoldingEntity } from './DeleteHoldingEntity';
import { EditHoldingEntity } from './EditHoldingEntity';
import { HoldingEntityImageTile } from './EditHoldingEntity.styles';
import { HoldingEntityActionMenuContent, HoldingEntityActionMenuWrapper, HoldingEntityRowCollapsible, HoldingEntityRowCollapsibleActionsWrapper, HoldingEntityRowCollapsibleArrow, HoldingEntityRowCollapsibleDefaultBadge, HoldingEntityRowCollapsibleDetailsWrapper, HoldingEntityRowCollapsibleHeader, HoldingEntityRowCollapsibleThreeDots, HoldingEntityRowCollapsibleTitle, ThreeDotsCircleWrapper } from './HoldingEntityRow.styles';

export const HoldingEntityRow = observer((props) => {
  const { uiStore, holdingEntityStore } = useStore();

  const updateHoldingEntity = (data) => {
    holdingEntityStore.updateHoldingEntity(data);
  }

  const deleteHoldingEntity = (id) => {
    holdingEntityStore.deleteHoldingEntity(id)
  }

  const PropsWithMethods = { ...props, updateHoldingEntity, deleteHoldingEntity, };

  return (
    <HoldingEntityRowDesktop {...PropsWithMethods} isMobileView={!uiStore.isDesktopView} />
  )
})


export const HoldingEntityRowDesktop = observer(({
  item = {},
  updateHoldingEntity,
  deleteHoldingEntity,
  isMobileView,
}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const bgColor = holdingEntityBackgroundColors.find((bgColor) => bgColor === item?.colorCode) || {};

  const handleDropdownVisibility = (visible) => {
    setDropdownVisible(visible);
  };

  const handleHoldingEntityRowCollapsibleOpenToggle = () => {
    if (isMobileView) {
      setIsEdit(true);
    } else {
      setDropdownVisible(!dropdownVisible);
    }
  }

  return (
    <HoldingEntityRowCollapsible onClick={handleHoldingEntityRowCollapsibleOpenToggle}>
      <HoldingEntityRowCollapsibleHeader>
        <HoldingEntityRowCollapsibleDetailsWrapper>
          <HoldingEntityImageTile
            image={bgColor}
            size={32}
          >
            <HoldingEntitySvg />
          </HoldingEntityImageTile>
          <HoldingEntityRowCollapsibleTitle>{item.name}</HoldingEntityRowCollapsibleTitle>
        </HoldingEntityRowCollapsibleDetailsWrapper>
        <HoldingEntityRowCollapsibleActionsWrapper>
          {item.isDefault && <HoldingEntityRowCollapsibleDefaultBadge><ModifiedTooltip title={'This is the default holding entity when an item is created'} placement="top">
            <div style={{ display: 'flex', alignItems: 'center' }}>Default <TooltipSvg /></div>
          </ModifiedTooltip>
          </HoldingEntityRowCollapsibleDefaultBadge>}
          {!isMobileView && <Dropdown
            overlay={HoldingEntityActionMenu({
              handleOnHoldingEntityEdit: () => { setIsEdit(true); setDropdownVisible(false) },
              handleOnHoldingEntityDelete: () => { setIsDelete(true); setDropdownVisible(false) },
              handleOnHoldingEntityDefaultChange: () => { updateHoldingEntity({ ...item, isDefault: !item.isDefault }); setDropdownVisible(false) },
              isDefault: item.isDefault
            })}
            trigger={['click']}
            placement="topRight"
            visible={dropdownVisible}
            onVisibleChange={handleDropdownVisibility}
            getPopupContainer={() => document.getElementById('preferencesPage')}
          >
            <HoldingEntityRowCollapsibleThreeDots onClick={(e) => { e.stopPropagation(); }}><ThreeDotsCircleWrapper><ThreeDotsSvg /></ThreeDotsCircleWrapper></HoldingEntityRowCollapsibleThreeDots>
          </Dropdown>}
          {isMobileView && <HoldingEntityRowCollapsibleArrow><CollapsibleArrowSvg /></HoldingEntityRowCollapsibleArrow>}
        </HoldingEntityRowCollapsibleActionsWrapper>
      </HoldingEntityRowCollapsibleHeader>


      {isEdit && <EditHoldingEntity isEdit item={item} onClose={(e) => { e.stopPropagation(); setIsEdit(false) }} onSave={(data) => { updateHoldingEntity(data); setIsEdit(false) }} onDelete={(id) => { deleteHoldingEntity(id); setIsEdit(false) }} />}
      {isDelete ?
        <DeleteHoldingEntity item={item} onClose={() => { setIsDelete(false) }} onDelete={() => { deleteHoldingEntity(item.id); }}
          relevantImage={bgColor}
        /> : null}
    </HoldingEntityRowCollapsible>
  )
})

const ThreeDotsSvg = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="2.66659" cy="7.99935" r="1.33333" fill="#1A1B1D" />
      <circle cx="7.99984" cy="7.99935" r="1.33333" fill="#1A1B1D" />
      <circle cx="13.3333" cy="7.99935" r="1.33333" fill="#1A1B1D" />
    </svg>
  )
}

function HoldingEntityActionMenu({
  handleOnHoldingEntityEdit,
  handleOnHoldingEntityDelete,
  handleOnHoldingEntityDefaultChange,
  isDefault = false
}) {

  return (
    <HoldingEntityActionMenuWrapper onClick={(e) => e.stopPropagation()}>
      <HoldingEntityActionMenuContent>
        <CommonActionMenuItem onClick={handleOnHoldingEntityEdit}>
          <EditPencilSvg /> Edit
        </CommonActionMenuItem>
        <CommonActionMenuItem onClick={handleOnHoldingEntityDefaultChange}>
          <SetDefaultSvg /> Set as default
          <div style={{ flex: 1 }} />
          <Switch
            checked={isDefault}
            size="small"
            className='holdingEntityDefaultSwitch' />
        </CommonActionMenuItem>
        <CommonActionMenuItem color={'red'} onClick={handleOnHoldingEntityDelete}>
          <DeleteIconContainer color={'red'}><DeleteIcon /></DeleteIconContainer>Delete
        </CommonActionMenuItem>
      </HoldingEntityActionMenuContent>
    </HoldingEntityActionMenuWrapper>
  )
}

const EditPencilSvg = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.3979 11.7988L12.0028 6.58895" stroke="black" strokeWidth="1.5" />
      <path d="M9.90681 19.5683L9.90585 20.3183C10.1101 20.3186 10.3056 20.2355 10.4472 20.0884L9.90681 19.5683ZM4.50304 14.3674L3.96267 13.8473C3.82105 13.9945 3.74556 14.193 3.75363 14.3971L4.50304 14.3674ZM4.70849 19.5617L3.95908 19.5913L3.98753 20.3107L4.70753 20.3117L4.70849 19.5617ZM14.6892 5.22602L18.6519 9.04001L19.6921 7.95926L15.7294 4.14526L14.6892 5.22602ZM18.6587 9.3935L9.36643 19.0482L10.4472 20.0884L19.7395 10.4337L18.6587 9.3935ZM5.04342 14.8875L14.3357 5.23278L13.2549 4.1926L3.96267 13.8473L5.04342 14.8875ZM9.90776 18.8183L4.70945 18.8117L4.70753 20.3117L9.90585 20.3183L9.90776 18.8183ZM5.45791 19.532L5.25246 14.3378L3.75363 14.3971L3.95908 19.5913L5.45791 19.532ZM18.6519 9.04001C18.7514 9.13576 18.7544 9.29402 18.6587 9.3935L19.7395 10.4337C20.4097 9.73732 20.3885 8.62948 19.6921 7.95926L18.6519 9.04001ZM15.7294 4.14526C15.033 3.47504 13.9252 3.49624 13.2549 4.1926L14.3357 5.23278C14.4314 5.1333 14.5897 5.13027 14.6892 5.22602L15.7294 4.14526Z" fill="black" />
      <path d="M20 19.5996H13" stroke="black" strokeWidth="1.5" />
    </svg>
  )
}

const HoldingEntitySvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M13.25 0.25H0.34375V16.4375C0.34375 17.2832 1.02931 17.9688 1.875 17.9688H8.21875V16.6563H1.875C1.75419 16.6563 1.65625 16.5583 1.65625 16.4375V1.5625H13.25C13.3708 1.5625 13.4688 1.66044 13.4688 1.78125V7.57812H14.7812V1.78125C14.7812 0.935564 14.0957 0.25 13.25 0.25ZM10.1371 9.75679C10.1928 9.44765 9.98727 9.15192 9.67813 9.09626C9.36899 9.04059 9.07326 9.24608 9.01759 9.55522C8.96231 9.86224 8.856 10.1632 8.71247 10.4545C8.3978 10.3254 8.07545 10.3223 7.86032 10.3223C6.85282 10.3223 5.87455 10.682 5.07121 11.2456C4.4176 11.7041 3.6904 12.4909 3.7131 13.5577C3.71969 13.8671 3.81333 14.213 4.13644 14.4264C4.40229 14.6019 4.71557 14.6031 4.89686 14.599C5.61904 14.5826 6.26298 14.3216 6.82154 14.0124C7.59922 13.582 8.27396 12.9633 8.82687 12.3108L8.85687 12.2752C8.89985 12.3312 8.94531 12.3874 8.99352 12.4427C9.25658 12.7443 9.65932 13.0514 10.1368 13.1429C10.8157 13.2731 11.5578 13.3341 12.3196 13.0575C12.5834 12.9617 12.8637 12.8231 13.1042 12.7043C13.2119 12.6511 13.3116 12.6018 13.3983 12.5621C13.4321 12.5466 13.454 12.5368 13.4713 12.5298C13.545 12.5577 13.6351 12.6139 13.7655 12.7172C13.796 12.7413 13.8329 12.7718 13.8741 12.8058C13.9906 12.902 14.1417 13.0268 14.2809 13.1183C14.7659 13.4371 15.4162 13.6792 16.1247 13.4313C16.3476 13.3534 16.5551 13.2535 16.7332 13.1669L16.7653 13.1512C16.9382 13.0671 17.0837 12.9963 17.2321 12.9395L17.2321 12.9395C17.2323 12.9395 17.2344 12.9387 17.239 12.9373C17.244 12.9358 17.2509 12.9339 17.2607 12.9314C17.2768 12.9274 17.2904 12.9244 17.3099 12.9201L17.3463 12.9119L17.3466 12.9118C17.4123 12.897 17.541 12.8678 17.6695 12.8007C17.948 12.6554 18.0559 12.3118 17.9105 12.0334C17.7665 11.7574 17.4278 11.6489 17.1507 11.7885L17.1496 11.7888C17.1444 11.7903 17.1286 11.7949 17.095 11.8025L17.0764 11.8067L17.0763 11.8067C17.0517 11.8122 17.0167 11.82 16.9858 11.8277C16.9419 11.8386 16.8859 11.8541 16.8258 11.8771C16.6286 11.9525 16.4399 12.0444 16.2769 12.1239L16.2768 12.1239L16.2357 12.1439C16.0546 12.232 15.9018 12.3042 15.7491 12.3577C15.5119 12.4406 15.2416 12.3886 14.9057 12.1677C14.8198 12.1113 14.7496 12.0531 14.6577 11.9769C14.6051 11.9333 14.5454 11.8838 14.4717 11.8254C14.3 11.6894 14.0638 11.5184 13.7682 11.4302C13.3857 11.3161 13.0977 11.4484 12.9353 11.523L12.9243 11.528C12.7693 11.5991 12.6377 11.6646 12.5161 11.7252L12.516 11.7252C12.3142 11.8257 12.1398 11.9126 11.9313 11.9883C11.4539 12.1616 10.9526 12.1411 10.3509 12.0258C10.2037 11.9975 10.0101 11.8777 9.85069 11.6949C9.76373 11.5952 9.6821 11.4807 9.58988 11.344L9.5541 11.2906C9.82373 10.8253 10.0373 10.3108 10.1371 9.75679ZM7.86032 11.4598C7.93403 11.4598 7.99676 11.4613 8.05097 11.4647C8.02073 11.5019 7.99007 11.5388 7.95904 11.5754C7.46639 12.1568 6.89421 12.6721 6.27069 13.0172C5.7902 13.2832 5.33352 13.4513 4.87105 13.4617L4.85125 13.4621C4.87337 12.9858 5.21596 12.5335 5.72451 12.1767C6.36643 11.7264 7.12074 11.4598 7.86032 11.4598Z" fill="#1A1B1D" />
    </svg>
  )
}

const SetDefaultSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" fill="none">
      <rect x="14" y="13" width="7" height="6" rx="1" stroke="#1A1B1D" strokeWidth="1.5" />
      <rect x="1" y="13" width="7" height="6" rx="1" stroke="#1A1B1D" strokeWidth="1.5" />
      <path d="M11 6.625L11 10L14.5 13" stroke="#1A1B1D" strokeWidth="1.5" />
      <path d="M11 6.625L11 10L7.5 13" stroke="#1A1B1D" strokeWidth="1.5" />
      <rect x="4" y="1" width="14" height="6" rx="1.25" stroke="#1A1B1D" strokeWidth="1.5" />
    </svg>
  )
}

const TooltipSvg = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M13.5 8.00087C13.5 11.0384 11.0366 13.5 7.99913 13.5C4.96165 13.5 2.5 11.0384 2.5 8.00087C2.5 4.96165 4.96165 2.5 7.99913 2.5C11.0366 2.5 13.5 4.96165 13.5 8.00087Z" fill="#9097A3" />
      <path d="M7.54138 7.28125H8.4579V10.9478H7.54138V7.28125Z" fill="white" stroke="white" strokeWidth="0.251429" />
      <path d="M7.54163 5.56568C7.54163 5.31259 7.7468 5.10742 7.99989 5.10742C8.25298 5.10742 8.45815 5.31259 8.45815 5.56568C8.45815 5.81877 8.25298 6.02394 7.99989 6.02394C7.7468 6.02394 7.54163 5.81877 7.54163 5.56568Z" fill="white" stroke="white" strokeWidth="0.628571" />
    </svg>
  )
}

const CollapsibleArrowSvg = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.48658 14.1816L12.5002 10.8483L16.5139 14.1816" stroke="black" strokeWidth="1.5" />
    </svg>
  )
}